export class HermesApiError extends Error {
  status: number;

  constructor(status: number, statusText: string) {
    super(`Hermes API error: ${status} ${statusText}`);
    this.name = "HermesApiError";
    this.status = status;
  }
}

/**
 * Typed fetch wrapper for the Hermes API that properly handles non-2xx
 * responses. Throws a `HermesApiError` when the response is not ok (e.g. 401),
 * so React Query correctly enters its error state instead of silently treating
 * error payloads as valid data.
 */
export async function hermesFetch<T>(
  url: string,
  apiToken: string | null,
  init?: RequestInit
): Promise<T> {
  const headers = new Headers(init?.headers);

  if (apiToken) {
    headers.set("Authorization", `Bearer ${apiToken}`);
  }

  if (!headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  // Allow credentials to be overridden, but default to include
  const credentials = init?.credentials ?? "include";

  const response = await fetch(url, { ...init, headers, credentials });

  if (!response.ok) {
    throw new HermesApiError(response.status, response.statusText);
  }

  return (await response.json()) as T;
}
